import {UISprite} from "./Tools/Base/UISprite";
import {UIText} from "./Tools/Base/UIText";
import {Core} from "../Base/Core";
import {Utils} from "../Utils/Utils";

export class UIBonusTimer extends UISprite {

    Awake() {
        super.Awake();
        this.icon = this.addChild(new UISprite("ico-clock"));
        this.label = this.addChild(new UIText("", {
            fill: 0xFF9900,
            fontSize: 16 * Core.app.renderer.resolution,
            fitTextTemplate: "000m 00s",
        }));
        this.SetActive(false);
    }

    Update(timerId) {
        let timer = Core.Player.Timers.GetTimerById(timerId);
        this.SetActive(timer && !timer.IsFinished);
        if (this.Active) {
            let m = ~~(timer.SecondsLeft / 60);
            let s = (timer.SecondsLeft % 60).toString().padStart(2, "0");
            let tpl = m ? "{0}m {1}s" : "{1}s";
            this.label.text = Utils.Format(tpl, m, s);
        }
    }

    fitLayout(rect) {
        // Make all timers in the game of the same size
        let size = Core.app.viewport.width * 0.05;
        this.position.copyFrom(rect);

        let iconRect = rect.clone().pad(
            -(rect.width - size) * 0.5,
            -(rect.height - size) * 0.5,
        );
        iconRect.x = iconRect.y = 0;
        this.icon.fitRect(iconRect);

        let labelRect = iconRect.clone().pad(iconRect.width * 2, -iconRect.height * 0.25);
        labelRect.y = iconRect.bottom - labelRect.height * 0.7;
        this.label.fitLayout(labelRect);
    }
}
